import styled from 'styled-components';
import { infiniteRotationAnimation } from 'styles/animations';

export const RichTextEditorCustomMentionListWrapper = styled.div`
  width: 228px;
  max-height: 175px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.1);

  overflow-y: auto;
`;

export const RichTextEditorCustomMentionListHeader = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 8px;

  padding: 4px 16px;
`;

export const RichTextEditorCustomMentionListHeaderText = styled.span`
  font-weight: 700;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const RichTextEditorCustomMentionListItemContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 8px;

  padding: 4px 16px;

  &:hover {
    background: #f7f7f7;
  }

  cursor: pointer;
`;

export const RichTextEditorCustomMentionListItemContainerText = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const RichTextEditorCustomMentionListItemType = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  text-align: right;

  color: var(--color-text-secondary);
  margin-left: auto;
  opacity: 0.7;
`;

export const RichTextEditorCustomMentionListLoadingContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4px 16px;

  svg {
    ${infiniteRotationAnimation()}
  }
`;
